// AU14-F3-F3-F1-F7 (docs/build-briefs/AU14-F3-F3-F1-F7-floor-card-removal-pending.md):
// what the floor says after a saved-card removal answers 200. The server commits
// the removal first and deletes the provider's token after; a 200 carrying
// providerDetachPending: true means the token is not confirmed deleted yet.
// No DOM, so a plain node:test file imports it (test/saved-card-removal-model.test.ts).

export type SavedCardRemovalState = "removed" | "pending";

/** Pending only on an explicit `true`; any other body is a completed removal. */
export function savedCardRemovalState(body: {
  providerDetachPending?: unknown;
}): SavedCardRemovalState {
  return body.providerDetachPending === true ? "pending" : "removed";
}

// PROVISIONAL copy (DEC-194): the owner or designer confirms the exact words.
export const CARD_REMOVED_TOAST = "Card removed.";
export const CARD_REMOVAL_PENDING_TOAST = "Card removed. Provider delete pending.";
export const CARD_RETRY_STILL_PENDING_TOAST = "Still pending.";
export const CARD_REMOVAL_PENDING_LABEL = "Removal pending";
export const CARD_REMOVAL_RETRY_LABEL = "Retry";

export function removalToast(state: SavedCardRemovalState): string {
  return state === "pending" ? CARD_REMOVAL_PENDING_TOAST : CARD_REMOVED_TOAST;
}

export function retryToast(state: SavedCardRemovalState): string {
  return state === "pending" ? CARD_RETRY_STILL_PENDING_TOAST : CARD_REMOVED_TOAST;
}

/** A removed card whose provider delete the floor is still waiting on. */
export interface PendingCardDetach {
  readonly savedCardId: string;
  readonly label: string;
  readonly guestLabel: string;
  /** The removal's idempotency key; Retry replays it. */
  readonly idempotencyKey: string;
}

export function withPending(
  list: readonly PendingCardDetach[],
  entry: PendingCardDetach,
): PendingCardDetach[] {
  return [...list.filter((e) => e.savedCardId !== entry.savedCardId), entry];
}

export function withoutPending(
  list: readonly PendingCardDetach[],
  savedCardId: string,
): PendingCardDetach[] {
  return list.filter((e) => e.savedCardId !== savedCardId);
}
